<template>
    <div class="col-md-12" >
    <h4 style="margin-top:5px;">Animal Details
       <b-button class="float-right" @click="go_back" variant="danger">
          <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
      </b-button>
    </h4>
    
    <hr />
    <div class="col-12" style="margin-top: 30px">
      <b-card-text>
        <center>
          <img src="../assets/111.jpg" height="250px" /><br />
          <h7><b>Name:Goat</b></h7
          ><br />
          <h7><b>Type:</b></h7
          ><br />
          <h7><b>Amount:5000</b></h7
          ><br />
          <h7><b>Tag No:</b></h7
          ><br />
          <h7><b>Daily Milk:</b></h7>
        </center>
      </b-card-text>
      <div class="btn-group col-12">
        <button type="button" class="btn btn-xs btn-primary col-6" @click="send_enquiry">
          Send Enquiry</button
        >&nbsp;
        <button type="button" class="btn btn-xs btn-primary col-6" @click="viewHandle">
          View Medical Certificate
        </button>
      </div>
    </div><br>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabIndex: 0,
    };
  },
  methods: {
     go_back(){
      this.$router.go(-1);
    },
     viewHandle(){
        this.$router.push("/home/viewmedical_certificate");
    },
    send_enquiry(){
        alert("Enquiry send to seller");
    },
  },
};
</script>